import React, { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { ApplicationState } from '../../store'
import BottomBar from './BottomBar'
import Topbar from './Topbar'
import SetTheme from '../../utils/SetTheme'
import RedeemFree from '../Elements/RedeemFree'
import RedeemSuccess from './../Deposit/RedeemSuccess'
import RedeemDialog from '../Deposit/RedeemDialog';
import NotifyWebSocket from '../../utils/NotifyWebSocket'
import { useAppContext } from '../../contexts/AppContext';

const AppLayout: FC = ({ children }) => {
	const prefixState = useSelector((state: ApplicationState) => state.prefix)
	const userState = useSelector((state: ApplicationState) => state.user)
	const loc = useLocation()

	// Context Redeem Free
	const {
		isOpenRedeemSuccess,
		setIsOpenRedeemSuccess,
		redeemAmount,
		isLoadedImagesRedeemSuccess,
		isOpenRedeemDialog,
		setIsOpenRedeemDialog,
		isModalSocket,
		setIsModalSocket,
		extraRedeemSuccess,
		setExtraRedeemSuccess
	} = useAppContext();


	useEffect(() => {
		if (!isLoadedImagesRedeemSuccess) {
			setIsOpenRedeemSuccess(true);

			const timer = setTimeout(() => {
				setIsOpenRedeemSuccess(false);
			}, 300);

			return () => {
				clearTimeout(timer);
				setIsOpenRedeemSuccess(false);
			};
		}
	}, []);

	return (
		<div className='container'>
			{loc.pathname !== '/play' && loc.pathname !== '/peer2pay' ? (
				<>
					<SetTheme />
					<Topbar
						prefix={prefixState.info}
						member={userState.info}
						pathname={loc.pathname}
					/>
					<div className='content'>
						{children}
					</div>
					<BottomBar member={userState.info} prefix={prefixState.info} />
					{prefixState.info?.bonusFreeStatus && <RedeemFree />}
					<RedeemDialog isOpen={isOpenRedeemDialog} onClose={() => setIsOpenRedeemDialog(false)} />
					<RedeemSuccess amount={redeemAmount} isOpen={isOpenRedeemSuccess} isLoadedImages={isLoadedImagesRedeemSuccess} onClose={() => { setIsOpenRedeemSuccess(false); setExtraRedeemSuccess(""); }} extraText={extraRedeemSuccess} />
				</>
			) : (
				<>
					<SetTheme />
					{children}
				</>
			)}
			{/* {(prefixState.info?.prefix === 'PGAUTO68' || prefixState.info?.prefix === 'MUMMY') && */}
			<NotifyWebSocket setIsModalSocket={setIsModalSocket} />
			{/* } */}
		</div>

	)
}

export default AppLayout
